<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>抢购详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-table border :data="act_list">
          <el-table-column prop="imei" label="IMEI序列号" align="center"></el-table-column>
          <el-table-column prop="platform" label="平台" align="center"></el-table-column>
          <el-table-column prop="product_name" label="活动名" align="center"></el-table-column>
          <el-table-column prop="price" label="商品价格" align="center"></el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              预约: <el-tag :type="scope.row && scope.row.is_sub == 1 ? 'success' : 'error'">
                {{ scope.row && scope.row.is_sub == 1 ? '成功' : '失败' }}
              </el-tag><br>
              购买:  <el-tag :type="scope.row && scope.row.is_buy == 1 ? 'success' : 'error'">
                {{ scope.row && scope.row.is_buy == 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_time" label="参与时间" align="center"></el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 15,
      act_list: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getActDetails();
    },
    getActDetails() {
      this.$ajax({
        url: "/tools/act/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.act_list = data.data.data;
        this.total = data.data.total;
      });
    },
  },
  mounted() {
    this.getActDetails();
  },
};
</script>